<template>
  <w-modal
    v-model="show"
    :submitButton="$t('buttons.save')"
    :title="$t(title)"
    :closeButton="$t('buttons.cancel')"
    :closeOnSubmitt="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="saveMedicalExamination"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-md-6">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-md-6">
        <form-datepicker :model="$schema.end" :title="$t($schema.end.$schema.title)" />
      </div>

      <div class="form-group col-md-12">
        <w-textarea :model="$schema.description" :title="$t($schema.description.$schema.title)" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/medicalExamination.schema';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({ name: '', description: '', profileId: null, teamId: null, end: '' });

// @vuese
// Modal badania lekarskiego
// @group Components
export default {
  mixins: [manageMixin('team/player/medicalExamination', {}, emptyData)],
  schema,
  computed: {
    title() {
      return this.id ? 'modals.medicalExaminationEdit' : 'modals.medicalExaminationAdd';
    },
    ...mapState({
      stateData: state => state.team.player.medicalExamination.data
    })
  },
  methods: {
    // @vuese
    // Zapisuje badanie medyczne
    saveMedicalExamination() {
      this.$schema.$model.profileId = tryParseInt(this.$route.params.playerId);
      this.$schema.$model.teamId = tryParseInt(this.$route.params.teamId);
      this.save();
    }
  }
};
</script>
